import * as React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import type { InjectedFormProps } from 'redux-form';
import { Field, FieldArray } from 'redux-form';

import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

import type { CompanyWorkDaysForm } from 'ab-requestModels/company.requestModel';

import { uniqueBy } from '@acceligentllc/shared/utils/array';
import { getAllHolidaysForNextYears } from '@acceligentllc/shared/utils/time';

import { weekDays } from '@acceligentllc/shared/enums/weekDay';

import Checkbox from 'af-fields/Checkbox';

import { HolidayOption } from './formModel';
import type { OwnProps as HolidayOwnProps } from './Holidays';
import HolidaysComponent from './Holidays';

interface OwnProps extends InjectedFormProps<CompanyWorkDaysForm> {
	onSubmit: (form: CompanyWorkDaysForm) => void;
	formName: string;
	company: CompanyViewModel;
}

type Props = OwnProps;

interface State {
	holidays: HolidayOption[];
}

export default class WorkDaysCompanyForm extends React.PureComponent<Props, State> {

	state: State = {
		holidays: [],
	};

	componentDidMount() {
		const holidays = getAllHolidaysForNextYears(4);
		const holidayNames: HolidayOption[] = Array.from(new Set(holidays.map((h) => new HolidayOption(h.name))));
		const alreadySelected: string[] = this.props.initialValues.holidays?.map((h) => h.name) ?? [];
		const filteredAndDistinct = uniqueBy(
			holidayNames.filter((h) => !alreadySelected.includes(h.name)),
			'name'
		);
		this.setState(() => ({ holidays: filteredAndDistinct }));
	}

	onSubmit = (form: CompanyWorkDaysForm) => {
		const { onSubmit } = this.props;
		onSubmit(form);
	};

	onValueChange = (holiday: HolidayOption) => {
		this.setState(
			(state: State) => ({ holidays: state.holidays.filter((h) => h.name !== holiday.name) })
		);
	};

	removeHoliday = (holiday: HolidayOption) => {
		this.setState((state) => ({ holidays: state.holidays.concat(holiday) }));
	};

	render() {
		const { handleSubmit, error } = this.props;
		const { holidays } = this.state;

		return (
			<Form className="update-workdays" onSubmit={handleSubmit(this.onSubmit)}>
				<Row className="row--padded">
					<Col className="update-workdays__days" md={6}>
						{weekDays.map((_d, _index) => (
							<Field
								component={Checkbox}
								inline={true}
								isStandalone={true}
								key={_index}
								label={_d}
								name={_d.toLowerCase()}
								type="text"
							/>
						))}
					</Col>
					<Col md={18}>
						<FieldArray<HolidayOwnProps>
							component={HolidaysComponent}
							name="holidays"
							onHolidayRemove={this.removeHoliday}
							onValueChange={this.onValueChange}
							options={holidays}
						/>
					</Col>
				</Row>
				{error && <span className="help-block"><span className="icon-info" /> {error}</span>}
			</Form>
		);
	}
}
